import * as React           from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink }          from 'react-router-dom'

import Divider      from '@material-ui/core/Divider'
import Drawer       from '@material-ui/core/Drawer'
import Hidden       from '@material-ui/core/Hidden'
import List         from '@material-ui/core/List'
import ListItem     from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import withStyles   from '@material-ui/core/styles/withStyles'

import { SettingsTool }                      from '../components/molecules'
import testingHooks                          from '../testing-hooks'
import { PrimitiveRoute, Routing, TopRoute } from '../types'

const GlobalDrawer = ({
  routing,
  isOpen,
  onClose,
  classes,
}: {
  routing: Routing,
  isOpen: boolean,
  onClose: () => void,
  classes: any,
}) => (
  <Drawer
    open={isOpen}
    anchor={'left'}
    onClose={onClose}
    classes={{ paper: classes.paper }}
  >
    <List component="nav">
      {routing.map(({ name, path, icon, subrouting }: TopRoute, i) => (
        <React.Fragment key={path}>
          <Hidden mdUp>
            <Divider />
          </Hidden>
          <NavLink to={path}>
            <ListItem
              divider
              data-test-id={testingHooks.drawerMenuListItem}
              button
              onClick={onClose}
            >
              {
                icon && (
                  <ListItemIcon>
                    {icon}
                  </ListItemIcon>
                )
              }
              <ListItemText
                data-test-id={testingHooks.drawerMenuListItemText}
                primary={<FormattedMessage id={'routing.' + name} />}
              />
            </ListItem>
          </NavLink>
          <Hidden mdUp>
            {subrouting.map(({ name, path: subPath, icon }: PrimitiveRoute) => (
              <NavLink
                key={path + subPath}
                to={path + subPath}
              >
                <ListItem
                  data-test-id={testingHooks.drawerMenuListItem}
                  button
                  onClick={onClose}
                >
                  {
                    icon && (
                      <ListItemIcon>
                        {icon}
                      </ListItemIcon>
                    )
                  }
                  <ListItemText
                    data-test-id={testingHooks.drawerMenuListItemText}
                    primary={<FormattedMessage id={'routing.' + name} />}
                  />
                </ListItem>
              </NavLink>
            ))}
          </Hidden>
        </React.Fragment>
      ))}
      <Hidden mdUp>
        <Divider />
      </Hidden>
      <SettingsTool />
    </List>
  </Drawer>
)

export default withStyles({
  paper: {
    width: 240,
  },
})(GlobalDrawer)



// WEBPACK FOOTER //
// ./src/routing/GlobalDrawer.tsx